<template>
  <a-modal
    :visible="value"
    title="将播主加入已有分组"
    :width="520"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <a-form-model
      class="form"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 140px' }"
      :wrapper-col="{ flex: '0 0 calc(100% - 140px)'}"
    >
      <a-form-model-item class="mb-0" label="已选播主" prop="authorIdList">
        {{ form.authorList.length }}
      </a-form-model-item>
      <a-form-model-item label="选择我创建的分组" prop="groupIdList">
        <a-checkbox-group v-model="form.groupIdList">
          <div class="group-wrap" v-for="item in groupList" :key="item.groupId">
            <a-checkbox :value="item.groupId" />
            <div>
              <span>{{ item.groupName }}</span>
              <span>({{ item.isCommon === 1 ? '公共分组' : '私有分组' }})</span>
            </div>
          </div>
        </a-checkbox-group>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <div class="btn-wrap">
        <div class="btn-wrap__left">
          <a-button class="btn-link" type="link" @click="handleAddGroup">
            新建分组
          </a-button>
        </div>
        <div class="btn-wrap__right">
          <a-button @click="handleCancel">
            取消
          </a-button>
          <a-button type="primary" :loading="confirmLoading" @click="handleConfirm">
            确定
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'JoinAuthorGroupModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default() {
        return {
          authorList: [],
          groupIdList: []
        }
      }
    },
    groupList: {
      type: Array,
      default() {
        return []
      }
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        groupIdList: [
          { type: 'array', required: true, message: '请至少选择一个分组', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleAddGroup() {
      this.$emit('add-group')
    },
    handleCancel() {
      this.$emit('input', false)
      this.$emit('cancel')
      this.resetForm()
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('confirm', { ...this.form })
        } else {
          return false
        }
      }) 
    },
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-0 {
  margin-bottom: 0;
}

.ant-form-item {
  display: flex;
}

.group-wrap {
  display: flex;
  align-items: flex-start;
  padding: 10px 0 0;

  .ant-checkbox-wrapper {
    margin-right: 8px;
    line-height: 20px;
  }

  & > div {
    word-break: break-all;
    word-wrap: break-word;
  }
}

.btn-wrap {
  display: flex;
  align-items: center;

  &__left {
    flex: 1;
    margin-right: 8px;
    text-align: left;
  }

  .btn-link {
    padding: 0;
  }
}
</style>
